module.exports = __webpack_public_path__ + "static/img/banner_login_2.7b0afa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/_app/wwka/src/assets/image/banner_login_2.png
// module id = HtAc
// module chunks = 63